// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T3H0","left":"styles_left__2dTh-","desktopActions":"styles_desktopActions__39-tX","title":"styles_title__2EXfL"};